export default __webpack_public_path__ + "static/media/eyeIcon.1f62cea9.svg";